import React from 'react'
import { Content, DefaultLayout } from '../layouts'
import { AddToChromeButton } from '@mote/presentation'
import { Block, BlockGroup, H2, H3, H4, H5, P } from '@mote/ui'

export const GmailScreen = () => {
  return (
    <DefaultLayout>
      <Content>
        <BlockGroup margin='20px 0 0 0' gap={60}>
          <Block layout='horizontal' gap={120}>
            <Block>
              <H2>
                <b className='mote-purple'>mote</b> for Gmail is here!
              </H2>
              <H4>Record and insert voice messages within Gmail</H4>
              <AddToChromeButton />
            </Block>
            <iframe
              width='480'
              height='270'
              title='mote-minute'
              src='https://www.youtube.com/embed/wXCBAc1NyCs'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
            />
          </Block>

          <Block>
            <H3>
              Send voice messages within Gmail with the mote Chrome extension
            </H3>
            <H5>Get started in three easy steps:</H5>
          </Block>

          <Block
            layout='horizontal'
            gap={80}
            align='center'
            justify='space-evenly'
          >
            <Block maxWidth={500} gap={15}>
              <H3 className='h3'>1. Add the extension</H3>
              <P fontSize={18}>
                If you've somehow missed all the buttons prompting you to do
                that,{' '}
                <a href='/chrome' className='mote-boiler-link'>
                  here's another link
                </a>{' '}
                in case you're still unsure where to do this!
              </P>
            </Block>

            <figure>
              <a href='/chrome'>
                <img
                  src='images/photos/chromeStore.png'
                  width='500'
                  alt='Chrome Store'
                />
              </a>
            </figure>
          </Block>

          <Block
            layout='horizontal'
            gap={80}
            align='center'
            justify='space-evenly'
          >
            <figure>
              <a href='/chrome'>
                <img
                  src='images/photos/gmailPermissions.png'
                  width='400'
                  alt='Permissions'
                />
              </a>
            </figure>
            <Block maxWidth={500} gap={15}>
              <H3 className='h3'>2. Confirm permissions</H3>
              <P fontSize={18}>
                Once the extension is added, you'll click the mote icon in your
                browser bar and be prompted to grant more permissions. This
                takes less than 5 seconds.
              </P>
            </Block>
          </Block>

          <Block
            layout='horizontal'
            gap={80}
            align='center'
            justify='space-evenly'
          >
            <Block maxWidth={500} gap={15}>
              <H3 className='h3'>3. Click to record</H3>
              <P fontSize={18}>
                You'll now see the <span className='mote-purple'>mote</span>{' '}
                icon in your Gmail 'compose' view whenever you start or respond
                to an email. So if you're not in a typing mood, just hit{' '}
                <span className='mote-purple'>mote</span>.
              </P>
            </Block>
            <figure>
              <a href='/chrome'>
                <img
                  src='images/photos/recordGmail.png'
                  width='500'
                  alt='Recording a mote'
                />
              </a>
            </figure>
          </Block>

          <Block align='center' margin='30px 0 100px 0' gap={20}>
            <H2 className='mb-4'>Are you ready to start?</H2>
            <AddToChromeButton />
          </Block>
        </BlockGroup>
      </Content>
    </DefaultLayout>
  )
}
